import { toast } from "react-toastify";
import { call, put, takeLatest } from "redux-saga/effects";
import { startLoader, stopLoader } from "../../../../utils/commonFunctions";
import { DepartmentSectionActionTypes, DepartmentSectionActions } from "../../../actionTypes/permissions/departmentSectionActionTypes";
import { getDepartmentSectionListApi, setDepartmentInSectionsApi } from "../../requests/permissions/departmentSectionRequests";
import { getDepartmentSectionList, setDepartmentSectionList } from "../../../actions/permissions/departmentSectionActions";


function* getDepartmentSectionListHandler(action: DepartmentSectionActionTypes) {
  // yield delay(500); //to hit search api after 500ms of the last key stroke
  try {
    yield startLoader("transparent");
    const { data } = yield call(getDepartmentSectionListApi);

    if (data.status) {
      yield put(setDepartmentSectionList(data.data))
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
  } finally {
    yield stopLoader("transparent");
  }
}


function* setDepartmentInSectionsHandler(action: DepartmentSectionActionTypes) {
  try {
    yield startLoader("transparent");
    const { data } = yield call(setDepartmentInSectionsApi, action.payload);

    if (data.status) {
      // toast message
      toast.success(data?.message, {
        position: "top-right",
      });
      yield put(getDepartmentSectionList()) //refetching after updating
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
  } finally {
    yield stopLoader("transparent");
  }
}



// Permission sagas
export default function* departmentSectionSaga() {
  yield takeLatest(DepartmentSectionActions.GET_DEPARTMENT_SECTION_LIST, getDepartmentSectionListHandler);
  yield takeLatest(DepartmentSectionActions.SET_DEPARTMENT_IN_SECTION, setDepartmentInSectionsHandler);
}
